import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import BloqLogo from "@/components/BloqLogo";
import api from "@/lib/api";
import { useAuth } from "@/contexts/AuthContext";

export default function AuthCallback() {
  const hasProcessed = useRef(false);
  const navigate = useNavigate();
  const { setUser } = useAuth();

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const hash = window.location.hash || "";
    const params = new URLSearchParams(hash.replace(/^#/, ""));
    const sessionId = params.get("session_id");
    if (!sessionId) {
      toast.error("Missing session — please try logging in again");
      navigate("/login");
      return;
    }
    (async () => {
      try {
        const { data } = await api.post("/auth/google/callback", { session_id: sessionId });
        if (data?.token) localStorage.setItem("bloq_token", data.token);
        setUser(data.user);
        toast.success(`Welcome${data.user?.name ? ", " + data.user.name.split(" ")[0] : ""}!`);
        // Brand-new Google signups land on Account Settings → Profile so
        // they can complete both timezone fields before doing anything
        // else. Returning users keep going to the dashboard as before.
        navigate(data?.is_new_user ? "/app/settings?tab=profile&newuser=1" : "/app");
      } catch (err) {
        toast.error("Could not complete sign-in");
        navigate("/login");
      }
    })();
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center gap-6 bg-[#fbfcfc]">
      <BloqLogo size={32} />
      <div className="bloq-spinner" />
      <p className="text-sm text-[#82828c]">Finishing your sign-in…</p>
    </div>
  );
}
